module.exports = __webpack_public_path__ + "img/map2.6b294e42.png";